<template>
  <ui-pin-input
    :model-value="digits"
    otp
    type="number"
    :disabled="disabled"
    class="gap-3"
    @update:model-value="(value) => $emit('update:modelValue', value.join(''))"
    @keydown.enter.prevent="() => $emit('enter')"
  >
    <ui-pin-input-group>
      <ui-pin-input-slot
        v-for="index in 3"
        :key="'code-a-' + index"
        :index="index - 1"
        :aria-label="tr('Digit :num', { ':num': index })"
      />
    </ui-pin-input-group>
    <ui-pin-input-separator class="text-muted-foreground" />
    <ui-pin-input-group>
      <ui-pin-input-slot
        v-for="index in 3"
        :key="'code-b-' + index"
        :index="index + 2"
        :aria-label="tr('Digit :num', { ':num': index + 3 })"
      />
    </ui-pin-input-group>
  </ui-pin-input>
</template>

<script>
/** Six-digit authentication code input (v-model is the code as a string). */
export default {
  name: 'AuthCodeInput',
  props: {
    modelValue: {
      type: String,
      required: false,
      default: () => '',
    },
    disabled: {
      type: Boolean,
      required: false,
      default: () => false,
    },
  },
  emits: [ 'update:modelValue', 'enter' ],
  computed: {
    digits() {
      return (this.modelValue ?? '').split('').slice(0, 6);
    },
  },
  methods: {
    focus() {
      this.$el.querySelector('input')?.focus();
    },
  },
};
</script>
